(function () {
    var burgers = document.querySelectorAll(".burger")

    burgers.forEach((e) => {
        e.addEventListener("click", () => {
            e.classList.toggle("open")
            const links = e.closest(".mainnav").querySelector(".nav-links")
            links.classList.toggle("show")
        })
    })


    const navMain = document.querySelector(".mainnav")

    let lastScroll = 0;
    if (navMain) {

        const navCollapse = navMain.querySelector(".navbar-collapse");
        navCollapse.addEventListener('shown.bs.collapse', () => {
            window.scrollTo(0, 0);
            navMain.classList.add("expanded")
        })
        navCollapse.addEventListener('hidden.bs.collapse', () => {
            navMain.classList.remove("expanded")
        })

        window.addEventListener("scroll", () => {
            if (window.scrollY == 0) {
                navMain.classList.remove("scrolled");
            } else {
                let currentScroll = window.scrollY;
                if (currentScroll - lastScroll > 0) {
                    navMain.classList.add("down")
                    navMain.classList.remove("up")
                } else {
                    navMain.classList.add("up")
                    navMain.classList.remove("down")
                }
                lastScroll = currentScroll;
                if (!navMain.classList.contains("scrolled")) {
                    navMain.classList.add("scrolled");
                }
            }
        })
    }


})();